/*
  Welche offenen Anfragen gehoeren auf die Verfuegbarkeits-Seite?

  Gefiltert wird ueber "category", nicht ueber "source". Laeuft eine
  Verfuegbarkeit oder ein Ferieneintrag ueber den Genehmigungs-Flow, liefert
  /api/web/approval die Anfrage als source "approval_request" und laesst die
  rohe availability-/holiday-Zeile bewusst weg (siehe _target_is_referenced in
  backend_web/approval.py). Ein Filter auf source === "availability" verliert
  damit genau die Anfragen, die /approval/flow anzeigt.

  Die Kategorie ist dagegen bei beiden Formen dieselbe: "absence" fuer
  Verfuegbarkeiten und freie Tage, "holiday" fuer Ferien. Stempelungen und
  Schichttausch bleiben aussen vor, die gehoeren nicht auf diese Seite.
*/
export const AVAILABILITY_APPROVAL_CATEGORIES = ["absence", "holiday"];

export const filterAvailabilityApprovals = (approvalRows) => (
  Array.isArray(approvalRows)
    ? approvalRows.filter((row) => AVAILABILITY_APPROVAL_CATEGORIES.includes(row?.category))
    : []
);
